export default __webpack_public_path__ + "static/media/cryptoicon.816ba139.svg";